import { fetchAPI } from "packs/api";

document.addEventListener("click", function (event) {
    const button = event.target.closest(".topic_vote_up, .topic_vote_down");
    if (!button) return; // Ignore clicks outside of vote buttons

    const topicLink = button.dataset.tlink;
    const forumType = button.dataset.ftype;
    const voteType = button.classList.contains("topic_vote_up") ? "voteup" : "votedown";

    // Select all topic votes
    document.querySelectorAll(".topic_vote").forEach((el) => {
        el.style.transition = "opacity 0.6s";
        el.style.opacity = "0.33";
        el.style.cursor = "default";
    });

    fetchAPI(`/${forumType}/${topicLink}/${voteType}`, "POST", {}, "script");
});
